<app-header></app-header>
<div class="mainContent">
  <section class="accountInfo pt-4 l-gray">
    <div class="container-fluid">
      <div class="accountInfo-verticalNav">
        <div class="accountInfo-wrapper">
          <ul
            *ngIf="user$ | async as user; else userMenuLoading"
            ngbnav=""
            orientation="vertical"
            class="nav-pills nav flex-column bg-white"
            role="tablist"
          >
            <li class="userImgName">
              <div class="user-img">
                <img
                  [src]="
                    user.gender === 'MALE'
                      ? 'assets/images/male.png'
                      : 'assets/images/female.png'
                  "
                  alt=""
                />
              </div>
              <div class="user-name">
                <h2>{{ user.firstName }} {{ user.lastName }}</h2>
                <!-- <p>حساب منظم</p> -->
              </div>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                routerLinkActive="active"
                [routerLink]="['./my-weapons']"
              >
                <i class="fas fa-bullseye"></i>
                {{ "My Weapons" | translate }}
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                routerLinkActive="active"
                [routerLink]="['./my-requests']"
              >
                <i class="fas fa-list"></i>
                {{ "My Weapon Access Requests" | translate }}
              </a>
            </li>
          </ul>
          <div class="tab-content">
            <router-outlet></router-outlet>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>

<ng-template #userMenuLoading>
  <ul
    ngbnav=""
    orientation="vertical"
    class="nav-pills nav flex-column bg-white"
  >
    <li class="userImgName">
      <div class="user-img">
        <span class="skeleton-box skeleton-box__image"></span>
      </div>
      <div class="user-name">
        <h2>
          <span class="skeleton-box"></span>
        </h2>
        <p><span class="skeleton-box"></span></p>
      </div>
    </li>
    <li class="nav-item">
      <a href="#" class="nav-link"><span class="skeleton-box"></span></a>
    </li>
    <li class="nav-item">
      <a href="#" class="nav-link"><span class="skeleton-box"></span></a>
    </li>
    <li class="nav-item">
      <a href="#" class="nav-link"><span class="skeleton-box"></span></a>
    </li>
  </ul>
</ng-template>

<app-footer></app-footer>
